
export function initBannerScrollAnimation() {
    if(window.innerWidth >= 768){
        const bannerScrollHead = document.querySelector(".bannerEila--scrollHeadToContent");
        const bannerTextcontent = bannerScrollHead ? bannerScrollHead.querySelector(".bannerEilaTextcontent") : null;

        if (!bannerTextcontent) return;

        // Hole die initiale bottom Position aus dem CSS
        const computedStyle = window.getComputedStyle(bannerTextcontent);
        const initialBottom = parseInt(computedStyle.bottom) || 0;

        let ticking = false;

        function updateBannerPosition() {
            const currentScrollY = window.scrollY;
            const scrollProgress = Math.min(currentScrollY / initialBottom, 1);
            const bottomValue = initialBottom - (initialBottom * scrollProgress);

            bannerTextcontent.style.bottom = `${bottomValue}px`;

            ticking = false;
        }

        window.addEventListener('scroll', function() {
            if (!ticking) {
                window.requestAnimationFrame(updateBannerPosition);
                ticking = true;
            }
        });
    }
}
